import useCurrentEventInfo from '@contexts/useCurrentEventInfo';
import { withAuthGate } from '@sunrise-ui/composites';
import { useSafeLocalSearchParams } from '@sunrise-ui/primitives';
import React, { useEffect } from 'react';

// placeholder, should never render this component and instead should render
// either [eventId].web.tsx or [eventId].mobile.tsx depending on platform
function EventScreen() {
  const { setCurrentEventId } = useCurrentEventInfo();
  const { eventId } = useSafeLocalSearchParams<{ eventId: string }>();

  useEffect(() => {
    // Just in case we end up here without setting it
    setCurrentEventId(eventId);
  }, []);

  return <></>;
}

export default withAuthGate(EventScreen);
